var ConsumptionInclude = {
    scope: true,
};
export var OrganizationConsumptionInclude = Object.assign({}, ConsumptionInclude);
export var ProductConsumptionInclude = Object.assign({}, ConsumptionInclude);
var ConsumptionSelect = {
    validBusinessUnitIds: false,
    outOfScope: false,
    version: false,
    deletedAt: false,
    deleted: false,
    id: true,
    createdAt: true,
    updatedAt: true,
    logEntryId: { where: { deleted: false } },
    scope: {
        select: {
            id: true,
            categoryNumber: true,
            subcategoryNumber: true,
            title: true,
        },
    },
    subcategory: {
        select: {
            id: true,
            name: true,
        },
    },
    logId: true,
    category: {
        select: {
            id: true,
            name: true,
        },
    },
    factor: true,
    organization: {
        select: {
            id: true,
            name: true,
        },
    },
    businessUnit: {
        select: {
            id: true,
            title: true,
        },
    },
    tags: true,
    value: true,
    timestamp: true,
};
export var OrganizationConsumptionSelect = Object.assign({
    location: {
        select: {
            id: true,
            name: true,
        },
    },
}, ConsumptionSelect);
export var ProductConsumptionSelect = Object.assign({
    product: {
        select: {
            id: true,
            name: true,
        },
    },
}, ConsumptionSelect);
//# sourceMappingURL=Consumption.js.map